/*
 * PROD-7828 — the Ops-facing IST calendar, shared by every tab. Dates here are IST dates, never the
 * browser's; IST has no DST, so a fixed +05:30 offset is exact.
 */
const IST_OFFSET_MIN = 330;
const pad = (n) => String(n).padStart(2, '0');

const ist_parts = (now) => {
  const d = new Date(now.getTime() + IST_OFFSET_MIN * 60000);
  return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
};

// The IST calendar date of an instant, as YYYY-MM-DD.
export const ist_day = (now = new Date()) => {
  const p = ist_parts(now);
  return `${p.year}-${pad(p.month)}-${pad(p.day)}`;
};

// The IST pay month of an instant, as YYYY-MM.
export const ist_month_key = (now = new Date()) => {
  const p = ist_parts(now);
  return `${p.year}-${pad(p.month)}`;
};
